const SERVER = (process.env.REACT_APP_SERVER || '').replace(/\/$/, '');

export function startNaverLogin({ browser = window } = {}) {
    // 서버가 state 쿠키를 설정한 뒤 네이버 인증 화면으로 리다이렉트한다.
    browser.location.assign(`${SERVER}/api/auth/naver`);
}
